import { AmlDetails, CommonLayout, Footer } from '../commonComponents';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {
  Box,
  Button,
  CardMedia,
  Grid,
  IconButton,
  LinearProgress,
  Typography,
  Dialog,
  Tooltip,
  Stepper,
  StepConnector,
  stepConnectorClasses,
  Step,
  StepButton,
  StepLabel,
  StepIconProps,
  StepIcon,
  Stack,
  Hidden,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { Theme, styled, useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getApplicationDetails,
  getDocuments,
  isFormValidForSubmission,
  nomineeOptOutResendOtp,
  nomineeOptOutVerifyOtp,
  nonIndividualFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import ContactDetails from './contactDetails';
import KycDetails from './kycDetails';
import FatcaDetails from './FatcaDetails';
import NomineeDetails from './nomineeDetails';
import InvestAndPaymentDetails from './InvestmentAndPayment';
import BankDetails from './BankDetails';
import DocumentDetails from './DocumentDetails';
import {
  ApplicationProps,
  Document,
  nationaliyType,
  NomineeOptOutVerifyOtpResponseBody,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import {
  REJECTED_ROLES,
  USER_ROLES,
  APPLICATION_STATUS,
  ApplicationStatusBasedOnRole,
  APPLICATION_TYPE,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  IndividualApplicationStatusBasedOnRole,
  APPLICATION_STATUS_AMCAPPROVER_individual,
  APPLICATION_LISTING_STATUS,
  PHYSICAL_DIGITAL_FLOW,
  ONBOARDING_DEMAT_DETAILS,
  NEXEDGE_INVESTMENT_PREFERENCE,
  onboardingTypeMasters,
  NOMINEE_OPT_OUT_FEATURE_ENABLED,
} from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import * as yup from 'yup';
import { Formik } from '../../lib/formik/Formik';
import CloseIcon from '@mui/icons-material/Close';
import { MFTextField } from '../../lib/formik';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import LoadingButton from '@mui/lab/LoadingButton';
import { formatShortDateAndTime } from '../../utils/date';
import {
  applyRoleBasedStatus,
  checkIfApplicationIsNonIndividual,
  isModuleAllowed,
  sendApplication_Nri,
} from '../../utils/utilityFunctions';
import { NonIndividualApplicationLayout } from '../NonIndividualApplicationDetails';
import { showError } from '../../redux-store/actions/auth';
import { ConfirmationDialog } from '../commonComponents';
import DistributorDetails from './rmDetails';
import RelatedPersonDetails from './relatedPersonDetails';
import { getNationalityList } from '../../redux-store/actions/userManagement';
import PersonalDetails from './personalDetails';
import RiskProfiles from './RiskProfiles';
import { riskProfileMasterData } from '../../redux-store/actions';
import { TermsAndConditionsCard } from './TermsAndConditions';
import ServicePreference from './servicePreferenceDetails';
import InvestmentPreference from './investmentPreferenceDetails';
import RMConcentForBSE from './rmConsentBse';
import Comments from './Comments';
import { EditIcon, StepperSuccessIcon, SuccessIcon } from '../../assets/SvgIcons';
import InvOnboardingLayout from '../InvestorOnboarding/InvOnboardingLayout';
import NexEdgeInvestmentPreference from './NexEdgeInvPref';
import DematDetails from './DematDetails';
import DuplicatePanApplications from './DuplicatePanApplications';
import OTPForm from '../../lib/formik/OtpForm';
import StepperLoading, { BootstrapStepConnector } from '../StepperLoading';
import KycStatusInfo from './KycStatusInfo';
import RiaFeeDetails from './RiaFeeDetails';

export const Item = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: '10px',
  marginLeft: '2px',
  color: theme.palette.text.secondary,
  fontSize: '15px',
  fontWeight: 500,
  letterSpacing: '0.5px',
}));
export const ItemDetails = styled('div')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  fontSize: '16px',
  marginLeft: '2px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  maxWidth: '100%',
  overflowWrap: 'anywhere',
}));
export const Gridstyles = styled('div')(({ theme }) => ({
  paddingLeft: '10%',
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    paddingLeft: 0,
  },
}));

export const NonIndividualMenuItemList = [
  'Distributor details',
  'Contributor Details',
  'Contact Details',
  'Investment & Payment Details',
  "Investor's Bank Details",
  ...(ONBOARDING_DEMAT_DETAILS ? ["Investor's DP Details"] : []),
  'Document Details',
  'Authorised Signatory',
  'Declaration of UBO',
  'FATCA',
  'RIA Fee'
  // 'Risk Profile',
];

export const MenuItemList = [
  'IA Details',
  'Personal Details',
  'Details of Related Person',
  'Contact Details',
  'Additional KYC Details',
  'Nominee Details',
  'FATCA Declaration',
  'Bank Details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['DP Details'] : []),
  'Risk Profiles',
  'Investment Preference',
  'RIA Fee',
  // 'Service Preference',
  'Upload Documents',
];

export const NonIndividualMenuItemListLink = [
  'distributor-details',
  'personal-details',
  'contact-details',
  'investment-payment-details',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['dp-details'] : []),
  'document-details',
  'authorised-signatory',
  'declaration-ubo',
  'fatca',
  'ria-fee',
  // 'risk-profile',
];

export const MenuItemListLink = [
  'rm-details',
  'personal-details',
  'related-person-details',
  'contact-details',
  'additional-KYC-details',
  'nominee-details',
  'fatca',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ["dp-details"] : []),
  'risk-profiles',
  'investment-preference',
  // 'service-preference',
  'ria-fee',
  'document-details',
];

export function RejectedDetails({
  title,
  description,
}: {
  title: string | null;
  description: string | null;
}): JSX.Element {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontSize: 17, fontWeight: 500, color: 'text.secondary' }}>
          {title}:{' '}
          <Typography
            component="span"
            sx={{
              color: 'text.secondary',
              fontSize: '16px',
              letterSpacing: '0.4px',
              fontWeight: 700,
              ml: { sm: 0.5 },
            }}>
            {description}
          </Typography>
        </Typography>
      </Grid>
    </>
  );
}

export function ApplicationDetailsCommonLayout({
  loading,
  application,
  setDuplicatePanApplicationCount = () => { return; },
  setDuplicatePanCheckboxValue = () => { return; },
  duplicatePanCheckboxValue = false,
  selectedFamilyId = { key: "", value: "" },
  setSelectedFamilyId = () => { return; },
}: {
  loading: boolean;
  application: ApplicationProps;
  setDuplicatePanApplicationCount?: Dispatch<SetStateAction<number>>;
  setDuplicatePanCheckboxValue?: Dispatch<SetStateAction<boolean>>;
  duplicatePanCheckboxValue?: boolean;
  selectedFamilyId?: { key: string, value: string };
  setSelectedFamilyId?: Dispatch<SetStateAction<{ key: string, value: string }>>;
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { path: currentPath } = useRouteMatch();
  const { onboardingVia = '' } = application || {};

  const isDiyInvOnboardingApplicationDetails = currentPath.includes('investor-onboarding-application-details')
  const isDiyInvOnboardingApplicationPreview = currentPath.includes('investor-onboarding-application-preview')
  const isComplianceApplicationDetailsScreen = currentPath.includes('compliance-application-details')

  return (
    <>
      {loading && <LinearProgress />}
      {(!loading && application) && (
        <>
          {/* <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
            }}
            mb={3}>
            <Box sx={{ p: 2 }}>
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  mb={2}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                    }}>
                    Application ID: {application.applicationNumber}
                  </Typography>
                  {application.clientCode && (
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: 'text.secondary',
                      }}>
                      Client Code : {application.clientCode}
                    </Typography>
                  )}
                  <Typography
                    className={
                      application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                    }
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                      '&.Draft .MuiTypography-root': {
                        color: 'rgba(51, 127, 201, 0.7)',
                      },
                      '&.Completed .MuiTypography-root': {
                        fontWeight: 600,
                        color: 'rgba(35, 133, 63, 0.7)',
                      },
                      '&.Rejected .MuiTypography-root': {
                        color: '#BD2932',
                        fontWeight: 500,
                      },
                    }}>
                    Status:{' '}
                    <Typography
                      component="span"
                      sx={{
                        color: '#B78813',
                        fontSize: '16px',
                        letterSpacing: '0.4px',
                        ml: 0.5,
                      }}>
                      {application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]}
                      {application.applicationSentBack ? ` (Sent Back)${application.sentBackByRole ? ` (By ${application.sentBackByRole.toLowerCase() === 'amcapprover' ? 'Checker' : 'Compliance'})` : ''}` : ''}
                      {application.status === 'rejected' && application.rejectedByRole ? ` (By ${REJECTED_ROLES[application.rejectedByRole] || application.rejectedByRole})` : ''}
                    </Typography>
                  </Typography>
                  {[
                    USER_ROLES.RM,
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.SUBDISTRIBUTOR,
                    USER_ROLES.AMCAPPROVER,
                    USER_ROLES.AMC_ADMIN,
                  ].includes(role) &&
                    application.signedLeegalityFile?.url && (
                      <Tooltip title={'Download'}>
                        <IconButton
                          sx={{
                            p: 0,
                            pr: 0.5,
                            ':hover': {
                              bgcolor: '#F4FCFC',
                            },
                            cursor: 'pointer',
                            pointerEvents: 'all',
                          }}
                          onClick={() =>
                            application.signedLeegalityFile?.url &&
                            window.open(application.signedLeegalityFile?.url)
                          }>
                          <CardMedia
                            component="img"
                            src={'/images/download-icon.png'}
                            alt="Download"
                            sx={{ width: '25px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                </Grid>
                {application.status === 'rejected' && (
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={1}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <RejectedDetails
                      title={'Rejected by'}
                      description={REJECTED_ROLES[application.rejectedByRole]}
                    />
                    <RejectedDetails
                      title={'Rejected on'}
                      description={formatShortDateAndTime(application.rejectedAt)}
                    />
                    <RejectedDetails
                      title={'Reason for rejection'}
                      description={application.rejectedReason}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box> */}
          {PHYSICAL_DIGITAL_FLOW && (<Typography
            variant='body_600'
            sx={(theme: Theme) => ({
              marginLeft: !isComplianceApplicationDetailsScreen ? "35px" : "0px",
              color: theme.palette.text.primary,
              mb: 1
            })}
          >
            {`Onboarding Type : ${onboardingVia?.toUpperCase()}`}
          </Typography>
          )}
          {[
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.OPM,
            USER_ROLES.ONBOARDING_SPECIALIST,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.IA
          ].includes(role) && (
              <div id="rm-details">
                <RMConcentForBSE application={application} />
              </div>
            )}
          {USER_ROLES.INVESTOR !== role && (
            <AmlDetails
              applicants={application?.applicants ?? []}
              applicationType={application?.applicationType ?? []}
            />
          )}
          {(isDiyInvOnboardingApplicationPreview || isDiyInvOnboardingApplicationDetails || role !== USER_ROLES.INVESTOR) && application?.comments?.length > 0 && (
            <Comments application={application} />
          )}
          {((application?.kycModificationStatusList ?? []).length > 0) && (
            <KycStatusInfo application={application} />
          )}
          {(isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview || role !== USER_ROLES.INVESTOR) && <DistributorDetails application={application} isDiyInvestorOnboarding={isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview} />}
          <div id='personal-details'>

            <PersonalDetails
              application={application}
              selectedFamilyId={selectedFamilyId}
              setSelectedFamilyId={setSelectedFamilyId}
            />
          </div>

          <div id="related-person-details">
            <RelatedPersonDetails applicants={application.applicants} />
          </div>
          <div id='contact-details'>

            <ContactDetails applicants={application.applicants} />
          </div>

          <div id='additional-KYC-details'>

            <KycDetails applicants={application.applicants} />
          </div>

          <div id='nominee-details'>

            <NomineeDetails application={application} />
          </div>
          <div id='fatca'>
            <FatcaDetails applicants={application.applicants} />
          </div>
          <div id="bank-details">

            <BankDetails banks={application.banks} application={application} />
          </div>
          {ONBOARDING_DEMAT_DETAILS && (
            <div id="dp-details">
              <DematDetails demats={application.demats} />
            </div>
          )}
          <div id='risk-profiles'>

            <RiskProfiles application={application} />
          </div>
          <div id='investment-preference'>
            {NEXEDGE_INVESTMENT_PREFERENCE ? <NexEdgeInvestmentPreference application={application} /> :
              <InvestmentPreference application={application} />}
          </div>
          {!NEXEDGE_INVESTMENT_PREFERENCE ? (
            <div id='service-preference'>
              <ServicePreference application={application} />
            </div>
          ) : null}
          <div id="ria-fee">
            <RiaFeeDetails application={application} />
          </div>
          <div id='document-details'>
            <DocumentDetails application={application} />
          </div>
          {[USER_ROLES.AMCAPPROVER].includes(`${role ?? ""}`.toLowerCase() as USER_ROLES) && (
            <Box mt={5}>
              <DuplicatePanApplications
                application={application}
                setDuplicatePanApplicationCount={setDuplicatePanApplicationCount}
                setDuplicatePanCheckboxValue={setDuplicatePanCheckboxValue}
                duplicatePanCheckboxValue={duplicatePanCheckboxValue}
              />
            </Box>
          )}
          <TermsAndConditionsCard application={application} />
        </>
      )}
    </>
  );
}

export const RejectApproveButtons = ({
  handleOpen,
  handleDialogOpen,
  handleSendBack,
  approve,
  reject,
  sendBack,
  duplicatePanApplicationCount = 0,
  duplicatePanCheckboxValue = false,
  loading = false
}: {
  handleOpen: () => void;
  handleDialogOpen: () => void;
  handleSendBack: () => void;
  approve: boolean;
  reject: boolean;
  sendBack: boolean;
  duplicatePanApplicationCount?: number;
  duplicatePanCheckboxValue?: boolean;
  loading?: boolean
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <>
      {!loading && (
        <Grid display="flex" justifyContent="center" alignItems="center">
          <LoadingButton
            loadingPosition="start"
            type="submit"
            loading={reject}
            variant="outlined"
            // sx={{
            //   fontSize: 15,
            //   minWidth: 180,
            //   letterSpacing: 2,
            //   fontWeight: 400,
            // }}
            sx={{
              color: 'primary.main',
              minWidth: { xs: '100px', sm: '150px', md: '200px' },
              mt: 4,
              fontWeight: 600,
              lineHeight: 1.1,
              mr: 3,
            }}
            onClick={handleOpen}
            disabled={approve || sendBack}>
            Reject
          </LoadingButton>
          <LoadingButton
            loadingPosition="start"
            type="submit"
            loading={approve}
            variant="contained"
            // sx={{
            //   fontSize: 15,
            //   minWidth: 180,
            //   letterSpacing: 2,
            //   fontWeight: 400,
            // }}
            sx={{
              color: 'common.white',
              minWidth: { xs: '100px', sm: '150px', md: '200px' },
              mt: 4,
              fontWeight: 600,
              lineHeight: 1.1,
              ml: 3,
              mr: USER_ROLES.AMCAPPROVER === role ? 3 : 0,
            }}
            onClick={handleDialogOpen}
            disabled={
              reject ||
              sendBack ||
              (duplicatePanApplicationCount > 1 && !duplicatePanCheckboxValue)
            }
          >
            Approve
          </LoadingButton>
          {/* {USER_ROLES.AMCAPPROVER === role && ( */}
          <LoadingButton
            loadingPosition="start"
            type="submit"
            loading={sendBack}
            variant="contained"
            sx={{
              color: 'common.white',
              minWidth: { xs: '100px', sm: '150px', md: '200px' },
              mt: 4,
              fontWeight: 600,
              lineHeight: 1.1,
              ml: 3,
            }}
            onClick={handleSendBack}
            disabled={reject || approve}>
            Send Back
          </LoadingButton>
          {/* )} */}
          {/* <Button
        variant="contained"
        sx={{
          color: 'common.white',
          minWidth: { xs: '100px', sm: '150px', md: '200px' },
          mt: 4,
          fontWeight: 600,
          lineHeight: 1.1,
          ml: 3,
        }}
        onClick={handleDialogOpen}>
        Approve
      </Button> */}
        </Grid>
      )}
    </>
  );
};

//Read only view for POA and Non Individual Application for AMC Approver,Individual Application for AMC Approver and POA Approver
const PoaOrNIApplicationDetails = ({
  loading,
  application,
}: {
  loading: boolean;
  application: ApplicationProps;
}): JSX.Element => {
  const { status, editable, applicationType, familyId } = application || {};
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR", locale = "en-IN" } = useSelector((store: RootStateType) => store.currencyInfo);
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [duplicatePanApplicationCount, setDuplicatePanApplicationCount] = useState<number>(0);
  const [duplicatePanCheckboxValue, setDuplicatePanCheckboxValue] = useState<boolean>(false)
  const [selectedFamilyId, setSelectedFamilyId] = useState<{ key: string; value: string }>({ key: "", value: "" })

  const location = useLocation()
  const { path, url } = useRouteMatch();
  // console.log('location', location);

  const validateForm = async () => {
    const nationalitiesMdmsMasters = (await dispatch(
      getNationalityList()
    )) as unknown as nationaliyType;
    const documentsResponse = (await dispatch(getDocuments())) as unknown as Document;
    const responseRiskProfile = (await dispatch(
      riskProfileMasterData({
        riskProfileGroup: application?.riskProfileGroup ?? null,
        company: application?.company ?? null
      })
    )) as unknown as RiskProfileMaster;
    if (application?.applicationType?.toLowerCase() === "individual") {
      await isFormValidForSubmission(
        application as ApplicationProps,
        true,
        true,
        nationalitiesMdmsMasters,
        documentsResponse,
        role,
        responseRiskProfile.riskProfile,
        currencyCode,
        company
      );
    }
    if (application?.applicationType?.toLowerCase() === "non_individual") {
      const { applicants = [] } = application || {};
      const getInvestorType = applicants[0]?.investorType?.toString();

      if (getInvestorType && Object.keys(documentsResponse).includes(getInvestorType)) {
        await nonIndividualFormValidForSubmission(
          application,
          documentsResponse[getInvestorType] ?? [],
          nationalitiesMdmsMasters.countries,
          undefined,
          currencyCode,
          locale,
          true
        );
      }
    }
  };

  const handleOpen = () => setOpen(true);
  const handleDialogOpen = async () => {
    if (
      // application?.applicationType === APPLICATION_TYPE.INDIVIDUAL &&
      !familyId &&
      !selectedFamilyId?.key &&
      !selectedFamilyId?.value
    ) {
      dispatch(showError(`Please select a family in ${application?.applicationType === APPLICATION_TYPE.INDIVIDUAL ? "Personal Details" : "Contributor Details"} section`))
      return
    }

    try {
      setApproveLoading(true);
      await validateForm();
      setApproveLoading(false);
      setOpenDialog(true);
    } catch (e) {
      setApproveLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);
  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const handleClose = () => {
    setOpen(false), setApproveLoading(false);
  };
  const handleDialogClose = () => {
    setOpenDialog(false), setRejectLoading(false);
  };

  const initialValues: Partial<ApplicationProps> = { rejectedReason: '' };
  const resonValidation = yup.object().shape({
    rejectedReason: yup.string().required('Please enter the reason for rejection'),
  });
  const onSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleClose();
      setRejectLoading(true);
      if (application) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              rejectedReason: values.rejectedReason,
              status: 'rejected',
            },
            applicationId: application.id,
          })
        );
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setRejectLoading(false);
    }
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      if (application) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              comment: values.comment,
              status: 'draft',
              applicationSentBack: true,
            },
            applicationId: application.id,
          })
        );
        history.push('/applications-list');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };
  return (
    USER_ROLES.AMCAPPROVER.includes(role)
      ?
      // <CommonLayoutForPOA>
      <CommonLayout>
        <>
          <Box sx={{ px: { xs: 2, sm: 5 }, mt: { xs: 2, sm: 3 } }} ref={applicationDetailRef}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                justifyContent: 'space-between',
                // mt: 5,
              }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "15px"
                }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications-list"
                    disabled={approveLoading || rejectLoading}>
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'text.primary' }} />
                  </IconButton>
                  <Typography
                    variant='h2'
                    sx={(theme: Theme) => ({
                      // fontSize: 20,
                      // fontWeight: 600,
                      color: theme.palette.primary[500]
                    })}
                  >
                    Application Details
                  </Typography>
                </Box>
                {!loading && (
                  <Typography
                    variant='body_600'
                    sx={(theme: Theme) => ({
                      marginLeft: "35px",
                      color: theme.palette.text.primary
                    })}
                  >
                    {application?.onboardingType?.toLowerCase() === "minor" ?
                      `Minor Investor ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                      ""
                    }
                    {(application?.onboardingType?.toLowerCase() === "normal" &&
                      application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                      `Individual Investor ${application?.accountType ?
                        '(' + application?.accountType + ')' : ''}` :
                      ""
                    }
                    {(application?.onboardingType?.toLowerCase() === "normal" &&
                      application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                      `Non Individual Investor ${application?.accountType ?
                        '(' + application?.accountType + ')' : ''}` :
                      ""
                    }
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end'
                }}
              >
                {editable && (
                  <IconButton>
                    <CardMedia
                      component="img"
                      src="/images/edit-icon-outlined.svg"
                      alt="Edit Icon"
                      sx={{ width: 'unset' }}
                      onClick={() =>
                        history.push(
                          role === USER_ROLES.POAAPPROVER
                            ? `/investment-details/edit-application`
                            : !checkIfApplicationIsNonIndividual(application) &&
                              USER_ROLES.AMCAPPROVER === role
                              ? `/application-checker-details/edit-application`
                              : `/non-individual-application-edit`,
                          {
                            id: application?.id,
                          }
                        )
                      }
                    />
                  </IconButton>

                )}
                {(application?.applicationNumber && path === "/application-details/:id") && (<Typography variant="body_600">{`Application ID: ${application?.applicationNumber}`}</Typography>)}

              </Box>
            </Box>
            <IconButton
              sx={{
                position: 'fixed',
                right: 0,
                bottom: 75,
                borderRadius: '5px  0 0 5px',
                '&,:hover': {
                  bgcolor: 'primary.main',
                },
              }}
              onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
              <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
            </IconButton>
            {applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (
              <NonIndividualApplicationLayout
                loading={loading}
                application={application}
                setDuplicatePanApplicationCount={setDuplicatePanApplicationCount}
                setDuplicatePanCheckboxValue={setDuplicatePanCheckboxValue}
                duplicatePanCheckboxValue={duplicatePanCheckboxValue}
                selectedFamilyId={selectedFamilyId}
                setSelectedFamilyId={setSelectedFamilyId}
              />
            ) : (
              <ApplicationDetailsCommonLayout
                loading={loading}
                application={application}
                setDuplicatePanApplicationCount={setDuplicatePanApplicationCount}
                setDuplicatePanCheckboxValue={setDuplicatePanCheckboxValue}
                duplicatePanCheckboxValue={duplicatePanCheckboxValue}
                selectedFamilyId={selectedFamilyId}
                setSelectedFamilyId={setSelectedFamilyId}
              />
            )}
            {application &&
              ((USER_ROLES.AMCAPPROVER === role && status === 'sent_to_amc_approver') ||
                (USER_ROLES.POAAPPROVER === role && status === 'sent_to_poa_approver') ? (
                <RejectApproveButtons
                  loading={loading}
                  handleOpen={handleOpen}
                  handleDialogOpen={handleDialogOpen}
                  approve={approveLoading}
                  reject={rejectLoading}
                  sendBack={sendBackLoading}
                  handleSendBack={handleSendBack}
                  duplicatePanApplicationCount={duplicatePanApplicationCount}
                  duplicatePanCheckboxValue={duplicatePanCheckboxValue}
                />
              ) : (
                (!loading && (
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      sx={{
                        color: 'common.white',
                        minWidth: '200px',
                        mt: 4,
                        fontWeight: 600,
                        lineHeight: 1.5,
                      }}
                      onClick={() => {
                        history.push('/applications-list');
                      }}>
                      Done
                    </Button>
                  </Box>
                ))
              ))}
            <Dialog
              onClose={handleClose}
              open={open}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Box sx={{ mb: 2 }}>
                <CardMedia
                  component="img"
                  src="/images/warning-icon-red.svg"
                  sx={{ width: 'unset', mx: 'auto' }}
                />
              </Box>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 18,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: '#BD2932' }}>
                    Reject
                  </Typography>{' '}
                  the application
                </Typography>
                <Typography sx={{ color: '#BD2932', mt: 5 }}>
                  {' '}
                  Give reason for application rejection *
                </Typography>
                <Formik
                  initialValues={initialValues}
                  onSubmit={onSubmit}
                  validationSchema={resonValidation}>
                  {({ handleSubmit }) => (
                    <Box component="form" noValidate onSubmit={handleSubmit}>
                      <MFTextField
                        name="rejectedReason"
                        multiline
                        rows={4}
                        placeholder="Type your answer here..."
                      />

                      <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                        <Button
                          onClick={() => {
                            handleClose();
                          }}
                          variant="outlined"
                          sx={{
                            fontSize: 15,
                            color: 'primary.main',
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 500,
                          }}>
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 400,
                          }}
                          type="submit">
                          Continue
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Formik>
              </Box>
            </Dialog>
            <Dialog
              onClose={handleDialogClose}
              open={openDialog}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleDialogClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 20,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: 'green' }}>
                    Approve
                  </Typography>{' '}
                  the application
                </Typography>
              </Box>
              <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleDialogClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  onClick={async () => {
                    try {
                      handleDialogClose();
                      setApproveLoading(true);
                      await dispatch(
                        updateApplication({
                          body: {
                            ...application,
                            ...((
                              // application?.applicationType === APPLICATION_TYPE.INDIVIDUAL && 
                              selectedFamilyId?.key &&
                              selectedFamilyId?.value
                            ) ? {
                              familyId: selectedFamilyId.value,
                              familyName: selectedFamilyId.key
                            } : {}),
                            status:
                              USER_ROLES.POAAPPROVER === role &&
                                application?.status === 'sent_to_poa_approver'
                                ? 'sent_to_amc_approver'
                                : USER_ROLES.AMCAPPROVER === role &&
                                  application?.status === 'sent_to_amc_approver'
                                  ? !application?.isEsignEnabled
                                    ? 'completed'
                                    : application?.hasPOA
                                      ? 'sent_to_authorised_signatories'
                                      : sendApplication_Nri(application) ||
                                        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                                          !checkIfApplicationIsNonIndividual(application))
                                        ? 'sent_to_applicant1'
                                        : 'sent_to_authorised_signatories'
                                  : application?.status,
                          },
                          applicationId: application.id,
                        })
                      );
                      history.push('/applications-list');
                    } catch (e) {
                      console.error((e as Error).message);
                    } finally {
                      setApproveLoading(false);
                    }
                  }}>
                  Continue
                </Button>
              </Grid>
            </Dialog>
            <Dialog
              onClose={handleSendBackClose}
              open={openSendBackDialog}
              sx={{
                '.MuiPaper-root ': {
                  p: 4,
                  width: { xs: '70%', sm: '70%' },
                },
              }}>
              <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
              {/* <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box> */}
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 18,
                    fontWeight: 500,
                    textAlign: 'justify',
                  },
                }}>
                <Typography sx={{ color: 'primary.main' }}>
                  Are you sure you want to{' '}
                  <Typography component="span" sx={{ color: '#BD2932' }}>
                    Send Back
                  </Typography>{' '}
                  the application
                </Typography>
                <Typography sx={{ color: '#BD2932', mt: 5 }}> Provide Comments *</Typography>
                <Formik
                  initialValues={initialCommentValues}
                  onSubmit={onSendBackSubmit}
                  validationSchema={Commentvalidation}>
                  {({ handleSubmit }) => (
                    <Box component="form" noValidate onSubmit={handleSubmit}>
                      <MFTextField
                        name="comment"
                        multiline
                        rows={4}
                        placeholder="Type your answer here..."
                      />

                      <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                        <Button
                          onClick={handleSendBackClose}
                          variant="outlined"
                          sx={{
                            fontSize: 15,
                            color: 'primary.main',
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 500,
                          }}>
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            minWidth: 180,
                            letterSpacing: 2,
                            fontWeight: 400,
                          }}
                          type="submit">
                          Continue
                        </Button>
                      </Grid>
                    </Box>
                  )}
                </Formik>
              </Box>
            </Dialog>
          </Box>
        </>
      </CommonLayout>
      //  </CommonLayoutForPOA >
      :
      (
        <Box
          sx={{
            bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
          }}>
          {/* <CommonLayoutForPOA> */}
          <CommonLayout>
            <>
              <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: { xs: 7, sm: 10 } }} ref={applicationDetailRef}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    justifyContent: 'space-between',
                    // mt: 5,
                  }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "15px"
                    }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton
                        sx={{ height: 'fit-content', p: 0 }}
                        component={RouterLink}
                        to="/applications-list"
                        disabled={approveLoading || rejectLoading}>
                        <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                      </IconButton>
                      <Typography
                        variant='h2'
                        sx={(theme: Theme) => ({
                          // fontSize: 20,
                          // fontWeight: 600,
                          color: theme.palette.primary[500]
                        })}
                      >
                        Application Details
                      </Typography>
                    </Box>
                    {!loading && (
                      <Typography
                        variant='body_600'
                        sx={(theme: Theme) => ({
                          marginLeft: "35px",
                          color: theme.palette.text.primary
                        })}
                      >
                        {application?.onboardingType?.toLowerCase() === "minor" ?
                          `Minor Investor ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                          ""
                        }
                        {(application?.onboardingType?.toLowerCase() === "normal" &&
                          application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                          `Individual Investor ${application?.accountType ?
                            '(' + application?.accountType + ')' : ''}` :
                          ""
                        }
                        {(application?.onboardingType?.toLowerCase() === "normal" &&
                          application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                          `Non Individual Investor ${application?.accountType ?
                            '(' + application?.accountType + ')' : ''}` :
                          ""
                        }
                      </Typography>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end'
                    }}
                  >
                    {editable && (
                      <IconButton>
                        <CardMedia
                          component="img"
                          src="/images/edit-icon-outlined.svg"
                          alt="Edit Icon"
                          sx={{ width: 'unset' }}
                          onClick={() =>
                            history.push(
                              role === USER_ROLES.POAAPPROVER
                                ? `/investment-details/edit-application`
                                : !checkIfApplicationIsNonIndividual(application) &&
                                  USER_ROLES.AMCAPPROVER === role
                                  ? `/investment-details/edit-application`
                                  : `/non-individual-application-edit`,
                              {
                                id: application?.id,
                              }
                            )
                          }
                        />
                      </IconButton>

                    )}
                    {(application?.applicationNumber && path === "/application-details/:id") && <Typography variant="body_600">{`Application ID: ${application?.applicationNumber}`}</Typography>}

                  </Box>
                </Box>
                <IconButton
                  sx={{
                    position: 'fixed',
                    right: 0,
                    bottom: 75,
                    borderRadius: '5px  0 0 5px',
                    '&,:hover': {
                      bgcolor: 'primary.main',
                    },
                  }}
                  onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
                  <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
                </IconButton>
                {applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? (
                  <NonIndividualApplicationLayout loading={loading} application={application} />
                ) : (
                  <ApplicationDetailsCommonLayout loading={loading} application={application} />
                )}
                {application &&
                  ((USER_ROLES.AMCAPPROVER === role && status === 'sent_to_amc_approver') ||
                    (USER_ROLES.POAAPPROVER === role && status === 'sent_to_poa_approver') ? (
                    <RejectApproveButtons
                      loading={loading}
                      handleOpen={handleOpen}
                      handleDialogOpen={handleDialogOpen}
                      approve={approveLoading}
                      reject={rejectLoading}
                      sendBack={sendBackLoading}
                      handleSendBack={handleSendBack}
                    />
                  ) : (
                    (!loading && (
                      <Box sx={{ textAlign: 'center' }}>
                        <Button
                          variant="contained"
                          sx={{
                            color: 'common.white',
                            minWidth: '200px',
                            mt: 4,
                            fontWeight: 600,
                            lineHeight: 1.5,
                          }}
                          onClick={() => {
                            history.push('/applications-list');
                          }}>
                          Done
                        </Button>
                      </Box>
                    ))
                  ))}
                <Dialog
                  onClose={handleClose}
                  open={open}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Box sx={{ mb: 2 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset', mx: 'auto' }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 18,
                        fontWeight: 500,
                        textAlign: 'center',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: '#BD2932' }}>
                        Reject
                      </Typography>{' '}
                      the application
                    </Typography>
                    <Typography sx={{ color: '#BD2932', mt: 5 }}>
                      {' '}
                      Give reason for application rejection *
                    </Typography>
                    <Formik
                      initialValues={initialValues}
                      onSubmit={onSubmit}
                      validationSchema={resonValidation}>
                      {({ handleSubmit }) => (
                        <Box component="form" noValidate onSubmit={handleSubmit}>
                          <MFTextField
                            name="rejectedReason"
                            multiline
                            rows={4}
                            placeholder="Type your answer here..."
                          />

                          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                            <Button
                              onClick={() => {
                                handleClose();
                              }}
                              variant="outlined"
                              sx={{
                                fontSize: 15,
                                color: 'primary.main',
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 500,
                              }}>
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontSize: 15,
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 400,
                              }}
                              type="submit">
                              Continue
                            </Button>
                          </Grid>
                        </Box>
                      )}
                    </Formik>
                  </Box>
                </Dialog>
                <Dialog
                  onClose={handleDialogClose}
                  open={openDialog}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleDialogClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 20,
                        fontWeight: 500,
                        textAlign: 'center',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: 'green' }}>
                        Approve
                      </Typography>{' '}
                      the application
                    </Typography>
                  </Box>
                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <Button
                      onClick={() => {
                        handleDialogClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      onClick={async () => {
                        try {
                          handleDialogClose();
                          setApproveLoading(true);
                          await dispatch(
                            updateApplication({
                              body: {
                                ...application,
                                status:
                                  USER_ROLES.POAAPPROVER === role &&
                                    application?.status === 'sent_to_poa_approver'
                                    ? 'sent_to_amc_approver'
                                    : USER_ROLES.AMCAPPROVER === role &&
                                      application?.status === 'sent_to_amc_approver'
                                      ? !application?.isEsignEnabled
                                        ? 'completed'
                                        : application?.hasPOA
                                          ? 'sent_to_authorised_signatories'
                                          : sendApplication_Nri(application) ||
                                            (AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                                              !checkIfApplicationIsNonIndividual(application))
                                            ? 'sent_to_applicant1'
                                            : 'sent_to_authorised_signatories'
                                      : application?.status,
                              },
                              applicationId: application.id,
                            })
                          );
                          history.push('/applications-list');
                        } catch (e) {
                          console.error((e as Error).message);
                        } finally {
                          setApproveLoading(false);
                        }
                      }}>
                      Continue
                    </Button>
                  </Grid>
                </Dialog>
                <Dialog
                  onClose={handleSendBackClose}
                  open={openSendBackDialog}
                  sx={{
                    '.MuiPaper-root ': {
                      p: 4,
                      width: { xs: '70%', sm: '70%' },
                    },
                  }}>
                  <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  {/* <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box> */}
                  <Box
                    sx={{
                      width: { xs: '100%', sm: '80%' },
                      mx: 'auto',
                      '.MuiTypography-root': {
                        fontSize: 18,
                        fontWeight: 500,
                        textAlign: 'justify',
                      },
                    }}>
                    <Typography sx={{ color: 'primary.main' }}>
                      Are you sure you want to{' '}
                      <Typography component="span" sx={{ color: '#BD2932' }}>
                        Send Back
                      </Typography>{' '}
                      the application
                    </Typography>
                    <Typography sx={{ color: '#BD2932', mt: 5 }}> Provide Comments *</Typography>
                    <Formik
                      initialValues={initialCommentValues}
                      onSubmit={onSendBackSubmit}
                      validationSchema={Commentvalidation}>
                      {({ handleSubmit }) => (
                        <Box component="form" noValidate onSubmit={handleSubmit}>
                          <MFTextField
                            name="comment"
                            multiline
                            rows={4}
                            placeholder="Type your answer here..."
                          />

                          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                            <Button
                              onClick={handleSendBackClose}
                              variant="outlined"
                              sx={{
                                fontSize: 15,
                                color: 'primary.main',
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 500,
                              }}>
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                fontSize: 15,
                                minWidth: 180,
                                letterSpacing: 2,
                                fontWeight: 400,
                              }}
                              type="submit">
                              Continue
                            </Button>
                          </Grid>
                        </Box>
                      )}
                    </Formik>
                  </Box>
                </Dialog>
              </Box>
              <Footer />
            </>
          </CommonLayout>
          {/* </CommonLayoutForPOA > */}
        </Box >
      )
  );
};

export default function ApplicationDetails(): JSX.Element {
  const theme = useTheme();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const [openDiyInvCheckerDialog, setDiyInvCheckerDialog] = useState<boolean>(false);
  const [isCurrentStatusNotDraft, setCurrentStatusNotDraft] = useState<boolean>(false)
  const [isOtpDialogOpen, setOtpDialogOpen] = useState<boolean>(false)
  const [verifyOtpSuccessData, setVerifyOtpSuccessData] = useState<{ isDialogOpen: boolean; data: NomineeOptOutVerifyOtpResponseBody | null }>({ isDialogOpen: false, data: null })
  const { path, url } = useRouteMatch();

  const isDiyInvOnboardingApplicationDetails = path.includes('investor-onboarding-application-details')
  const isDiyInvOnboardingApplicationPreview = path.includes('investor-onboarding-application-preview')

  const routerUrl = url.substring(0, url.lastIndexOf('/'))

  //new 
  const { application: applicationDetail } = useSelector((store: RootStateType) => store.application);
  const { currentStep } = applicationDetail || {};

  // In case of Nominee Otp out, we need to authenticate nominee opt out
  // When doNotWishToNominate = true and isBSEEnabled = true and isNomineeOptOutAuthenticated != '1'

  const isNomineeOptOutAuthRequired = applicationDetail?.doNotWishToNominate && applicationDetail?.isBSEEnabled && (applicationDetail?.isNomineeOptOutAuthenticated !== '1')

  // Individual Onboarding

  const isIndividualOnboarding = (
    isModuleAllowed({ value: (applicationDetail?.onboardingType ?? ""), compareArr: [onboardingTypeMasters.normal] }) &&
    isModuleAllowed({ value: (applicationDetail?.applicationType ?? ""), compareArr: [APPLICATION_TYPE.INDIVIDUAL] })
  )

  useEffect(() => {
    (async function () {
      try {
        const _application = (await dispatch(
          getApplicationDetails(id)
        )) as unknown as ApplicationProps;
        setCurrentStatusNotDraft(_application?.status?.toLowerCase() !== 'draft')
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    })();
    setLoading(true);
  }, []);

  const { editable, hasPOA, applicationSentBack = false } = applicationDetail || {};
  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);

  const menuList =
    applicationDetail &&
    (applicationDetail.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? NonIndividualMenuItemList
      : MenuItemList);

  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      const { id, status } = applicationDetail || {};

      let currentStatus = status

      if (isIndividualOnboarding && isNomineeOptOutAuthRequired && NOMINEE_OPT_OUT_FEATURE_ENABLED) {
        currentStatus = "draft"
      } else if (isDiyInvOnboardingApplicationPreview) {
        currentStatus = 'sent_to_amc_approver'
      } else if (hasPOA) {
        currentStatus = 'sent_to_poa_approver'
      } else if (
        sendApplication_Nri(applicationDetail) ||
        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
      ) {
        // currentStatus = 'sent_to_amc_approver'
        currentStatus = 'sent_to_compliance'
      } else if (!AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)) {
        currentStatus = 'sent_to_applicant1'
      }

      if (id) {
        const response = (await dispatch(
          updateApplication({
            body: {
              ...applicationDetail,
              status: currentStatus,
              comment: values.comment,
              applicationSentBack: false,
              ...((
                isIndividualOnboarding &&
                isNomineeOptOutAuthRequired &&
                NOMINEE_OPT_OUT_FEATURE_ENABLED
              ) ? {
                sentForNomineeOptOutAuthentication: "1",
                isNomineeOptOutStep: '1'
              } : {})
            },
            applicationId: id,
          })
        )) as unknown as ApplicationProps;

        if (!response) return

        if (isIndividualOnboarding && isNomineeOptOutAuthRequired && NOMINEE_OPT_OUT_FEATURE_ENABLED) {
          setOtpDialogOpen(true)
        } else {

          setCurrentStatusNotDraft(response?.status?.toLowerCase() !== 'draft')

          if (isDiyInvOnboardingApplicationPreview) {
            setDiyInvCheckerDialog(true)
            return
          }

          history.push('/applications');
        }
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };
  const handleSubmit = async () => {
    try {
      const { id, status } = applicationDetail || {};

      let currentStatus = status

      if (isIndividualOnboarding && isNomineeOptOutAuthRequired && NOMINEE_OPT_OUT_FEATURE_ENABLED) {
        currentStatus = "draft"
      } else if (isDiyInvOnboardingApplicationPreview) {
        currentStatus = "sent_to_amc_approver"
      } else if (hasPOA) {
        currentStatus = 'sent_to_poa_approver'
      } else if (
        sendApplication_Nri(applicationDetail) ||
        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
      ) {
        // currentStatus = 'sent_to_amc_approver'
        currentStatus = 'sent_to_compliance'
      } else if (!AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)) {
        currentStatus = 'sent_to_applicant1'
      }

      setIsSubmitting(true);
      if (id) {
        const response = (await dispatch(
          updateApplication({
            body: {
              ...applicationDetail,
              status: currentStatus,
              ...((
                isIndividualOnboarding &&
                isNomineeOptOutAuthRequired &&
                NOMINEE_OPT_OUT_FEATURE_ENABLED
              ) ? {
                sentForNomineeOptOutAuthentication: "1",
                isNomineeOptOutStep: '1'
              } : {})
            },
            applicationId: id,
          })
        )) as unknown as ApplicationProps;

        if (!response) return

        if (isIndividualOnboarding && isNomineeOptOutAuthRequired && NOMINEE_OPT_OUT_FEATURE_ENABLED) {
          setOtpDialogOpen(true)
        } else {

          setCurrentStatusNotDraft(response?.status?.toLowerCase() !== 'draft')

          if (isDiyInvOnboardingApplicationPreview) {
            setDiyInvCheckerDialog(true)
            return
          }

          history.push('/applications');
        }
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const LayoutComponent = (isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? InvOnboardingLayout : CommonLayout;

  let sendToActionBtnText = 'Send to Investor'

  if (isIndividualOnboarding && isNomineeOptOutAuthRequired && NOMINEE_OPT_OUT_FEATURE_ENABLED) {
    sendToActionBtnText = "Authenticate Nominee Opt out"
  } else if (isDiyInvOnboardingApplicationPreview) {
    sendToActionBtnText = "Submit for Approval"
  } else if (applicationDetail?.hasPOA) {
    sendToActionBtnText = "Send to POA Approver"
  } else if (sendApplication_Nri(applicationDetail) || (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))) {
    // sendToActionBtnText = "Send to Checker"
    sendToActionBtnText = "Send to Compliance"
  }

  const handleSendToActionBtnClick = async () => {
    if (
      (sendApplication_Nri(applicationDetail) ||
        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role, isDiyInvOnboardingApplicationPreview))) &&
      applicationSentBack
    ) {
      handleSendBack()
    } else if (isIndividualOnboarding && isNomineeOptOutAuthRequired && NOMINEE_OPT_OUT_FEATURE_ENABLED) {
      await handleSubmit()
    } else {
      setDialog(true)
    }
  }

  const handleOtpDialogClose = () => {
    setOtpDialogOpen(false)
  }

  const handleNomineeOptOutOtpSubmit = async (otp: string) => {
    const payload = {
      id: Number(applicationDetail?.otpRecordId ?? ""), //otpRecordId
      token: applicationDetail?.token ?? "", //token
      otp,
      applicationId: Number(applicationDetail?.applicationId ?? "") //applicationId
    }

    const response = await dispatch(nomineeOptOutVerifyOtp(payload)) as unknown as NomineeOptOutVerifyOtpResponseBody;

    if (!response) {
      return
    }

    if (!response?.isSuccess) {
      dispatch(showError(response?.message ?? ""))
      return
    }

    if (response?.isSuccess) {
      setOtpDialogOpen(false)

      setVerifyOtpSuccessData({
        isDialogOpen: true,
        data: response
      })
    }
  }

  const handleVerifyOtpSuccessDialogClose = () => {
    setVerifyOtpSuccessData({
      isDialogOpen: false,
      data: null
    })

    history.push('/applications');
  }

  const handleNomineeOptOutOtpResend = async () => {
    const payload = {
      id: Number(applicationDetail?.otpRecordId ?? ""), //otpRecordId
      token: applicationDetail?.token ?? "", //token
      applicationId: Number(applicationDetail?.applicationId ?? "") //applicationId
    }

    await dispatch(nomineeOptOutResendOtp(payload)) as unknown as ApplicationProps;
  }

  // return [
  //   USER_ROLES.AMC_ADMIN,
  //   USER_ROLES.RM,
  //   USER_ROLES.DISTRIBUTOR,
  //   USER_ROLES.SUBDISTRIBUTOR,
  //   USER_ROLES.AMC_ADMIN,
  //   USER_ROLES.INVESTOR,
  //   USER_ROLES.ONBOARDING_SPECIALIST
  // ].includes(role) ? (
  return (![USER_ROLES.AMCAPPROVER].includes(role)) ? (
    <LayoutComponent>
      <>
        <Box component={'div'} style={{ marginBottom: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px' }}>
          {["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) ? (
            <Typography variant='h1' sx={{ color: 'text.primary' }}>
              {applicationDetail?.onboardingType?.toLowerCase() === "minor" ?
                `Minor Investor Onboarding ${applicationDetail?.accountType ? '(' + applicationDetail?.accountType + ')' : ''}` :
                ""
              }
              {(applicationDetail?.onboardingType?.toLowerCase() === "normal" &&
                applicationDetail?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                `Individual Investor Onboarding ${applicationDetail?.accountType ?
                  '(' + applicationDetail?.accountType + ')' : ''}` :
                ""
              }
              {(applicationDetail?.onboardingType?.toLowerCase() === "normal" &&
                applicationDetail?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                `Non Individual Investor Onboarding ${applicationDetail?.accountType ?
                  '(' + applicationDetail?.accountType + ')' : ''}` :
                ""
              }
            </Typography >
          ) : (
            [USER_ROLES.AMC_ADMIN].includes(role) ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "20px"
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications"
                  // disabled={approveLoading || rejectLoading}
                  >
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
                </Box>
                {!loading && (
                  <Typography variant='h2' sx={{ color: 'text.primary', marginLeft: "35px" }}>
                    {applicationDetail?.onboardingType?.toLowerCase() === "minor" ?
                      `Minor Investor ${applicationDetail?.accountType ? '(' + applicationDetail?.accountType + ')' : ''}` :
                      ""
                    }
                    {(applicationDetail?.onboardingType?.toLowerCase() === "normal" &&
                      applicationDetail?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                      `Individual Investor ${applicationDetail?.accountType ?
                        '(' + applicationDetail?.accountType + ')' : ''}` :
                      ""
                    }
                    {(applicationDetail?.onboardingType?.toLowerCase() === "normal" &&
                      applicationDetail?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                      `Non Individual Investor ${applicationDetail?.accountType ?
                        '(' + applicationDetail?.accountType + ')' : ''}` :
                      ""
                    }
                  </Typography>
                )}
              </Box>
            ) : (
              <Box>
                <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
                {!loading && (
                  <Typography variant='h2' sx={{ color: 'text.primary', marginTop: "20px" }}>
                    {applicationDetail?.onboardingType?.toLowerCase() === "minor" ?
                      `Minor Investor Onboarding ${applicationDetail?.accountType ? '(' + applicationDetail?.accountType + ')' : ''}` :
                      ""
                    }
                    {(applicationDetail?.onboardingType?.toLowerCase() === "normal" &&
                      applicationDetail?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                      `Individual Investor Onboarding ${applicationDetail?.accountType ?
                        '(' + applicationDetail?.accountType + ')' : ''}` :
                      ""
                    }
                    {(applicationDetail?.onboardingType?.toLowerCase() === "normal" &&
                      applicationDetail?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                      `Non Individual Investor Onboarding ${applicationDetail?.accountType ?
                        '(' + applicationDetail?.accountType + ')' : ''}` :
                      ""
                    }
                  </Typography>
                )}
              </Box>
            )
            // <Typography variant='h1' sx={{ color: 'text.primary' }}>Application Details</Typography>
          )}
          {["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) && (<Typography sx={{ fontWeight: '500', fontSize: 16, letterSpacing: '0.02px', color: 'text.primary' }}>{`Application ID: ${applicationDetail?.applicationNumber}`}</Typography>)}
        </Box>
        <Grid container sx={(theme: Theme) => ({
          p: "35px",
          border: `1px solid ${theme.palette.text.primary}80`,
          borderRadius: "15px",
          background: theme.palette.background.paper,
          position: 'relative'
        })}>
          <Hidden lgDown={true}>
            <Grid item xs={12} lg={3} sx={{ padding: 0, position: 'sticky', top: '18px' }}>
              <Stack sx={{ position: 'sticky', top: '18px', pl: 4, py: 3, display: { lg: 'block', xl: 'block' } }}>
                {/* Stepper */}

                {loading && (
                  <StepperLoading stepCount={11} />
                )}

                {!loading && (
                  <Stepper
                    activeStep={currentStep ?? 0}
                    orientation="vertical"
                    connector={<BootstrapStepConnector />}
                    sx={{
                      "&.MuiStepper-vertical": {
                        ".MuiStepButton-vertical": {
                          ".MuiStepLabel-vertical": {
                            paddingTop: "0px",
                            paddingBottom: "0px"
                          }
                        }
                      }
                    }}
                  >
                    {menuList &&
                      menuList.map((item, index) => {
                        const isItemDisabled = !currentStep ? index !== 0 : index > currentStep;

                        return <Step key={index}>
                          <StepButton
                            href={
                              isDiyInvOnboardingApplicationPreview
                                ? ""
                                : isDiyInvOnboardingApplicationDetails
                                  ? `#${MenuItemListLink[index]}`
                                  : routerUrl === '/application-details' ? !isItemDisabled && applicationDetail && applicationDetail.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? `#${NonIndividualMenuItemListLink[index]}` : `#${MenuItemListLink[index]}` : ''
                            }
                            onClick={() =>
                              isDiyInvOnboardingApplicationDetails
                                ? null
                                : isDiyInvOnboardingApplicationPreview
                                  ? history.replace(
                                    `/investor-onboarding-application/${MenuItemListLink[index]}`,
                                    {
                                      id: applicationDetail.id,
                                      applicant1ReferenceId: applicationDetail.applicant1ReferenceId,
                                    }
                                  )
                                  : routerUrl !== '/application-details' ? !isItemDisabled &&
                                    history.replace(
                                      `${applicationDetail &&
                                      (applicationDetail.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                                        ? `/application/${NonIndividualMenuItemListLink[index]}`
                                        : `/application/${MenuItemListLink[index]}`)
                                      }`,
                                      {
                                        id: applicationDetail.id,
                                        applicant1ReferenceId: applicationDetail.applicant1ReferenceId,
                                      }
                                    ) : null
                            }
                          >
                            <StepLabel
                              sx={(theme: Theme) => ({
                                "& .MuiStepLabel-label.Mui-completed": {
                                  ...theme.typography.body_500,
                                  color: theme.palette.text.secondary,
                                },
                                "& .MuiStepLabel-label.Mui-active": {
                                  ...theme.typography.body_500,
                                  color: theme.palette.primary[500]
                                },
                                "& .MuiStepLabel-label.Mui-disabled": {
                                  ...theme.typography.body_500,
                                  color: theme.palette.text.secondary,
                                },
                                "& .MuiStepLabel-iconContainer.Mui-active": {
                                  "& .MuiStepIcon-root.Mui-active": {
                                    color: theme.palette.primary[500]
                                  },
                                  "& .MuiStepIcon-text": {
                                    ...theme.typography.subtitle_500,
                                    fill: theme.palette.textDark.primary
                                  }
                                },
                                "& .MuiStepLabel-iconContainer.Mui-disabled": {
                                  "& .MuiStepIcon-root": {
                                    color: theme.palette.grey[100]
                                  },
                                  "& .MuiStepIcon-text": {
                                    ...theme.typography.subtitle_500,
                                    fill: theme.palette.text.secondary
                                  }
                                }
                              })}
                              StepIconComponent={({ completed, ...props }: StepIconProps) => (
                                <StepIcon {...props} icon={completed ? <StepperSuccessIcon /> : props.icon} />
                              )}
                            >
                              {item}
                            </StepLabel>
                          </StepButton>
                        </Step>
                      })}
                  </Stepper>
                )}
              </Stack>
            </Grid>
          </Hidden>
          <Grid item
            container
            md={12}
            lg={9}
            sx={(theme: Theme) => ({
            })}
          >
            <Box component={'div'} style={{ padding: '35px', border: `1px solid ${theme.palette.text.primary}80`, borderRadius: '15px', backgroundColor: `${theme.palette.common.white}`, width: '100%' }}>
              <Box
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 5 }}
                ref={applicationDetailRef}>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  {path === "/investor-onboarding-application-preview/:id" ? (
                    <>
                      <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                        Summary
                      </Typography>
                    </>
                  ) : path === "/application-preview/:id" ? (
                    <>
                      <IconButton
                        sx={{ height: 'fit-content', p: 0 }}
                        component={RouterLink}
                        to="/applications">
                        <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                      </IconButton>

                      <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                        Summary
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', }}>
                        <Box >

                          <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                            <Typography
                              variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                            >
                              Application ID:{' '}
                            </Typography>
                            <Typography
                              variant="h2"
                              sx={{
                                display: 'inline',
                                color: 'text.primary',

                              }}
                            >
                              {loading ? '-' : applicationDetail?.applicationNumber}
                            </Typography>
                          </Typography>

                          <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                            <Typography
                              variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                            >
                              Status:{' '}
                            </Typography>
                            <Typography
                              variant="h2"
                              sx={(theme: Theme) => ({
                                display: 'inline',
                                color: applicationDetail?.status === 'draft' ? theme.palette.primary[500] : theme.palette.warning[500],
                                textTransform: 'capitalize'

                              })}
                            >
                              {loading ? '-' : `${APPLICATION_LISTING_STATUS[applicationDetail?.status ?? ''] ?? "-"}${applicationDetail?.applicationSentBack ? ` (Sent Back)${applicationDetail?.sentBackByRole ? ` (By ${applicationDetail.sentBackByRole.toLowerCase() === 'amcapprover' ? 'Checker' : 'Compliance'})` : ''}` : ''}${applicationDetail?.status === 'rejected' && applicationDetail?.rejectedByRole ? ` (By ${REJECTED_ROLES[applicationDetail.rejectedByRole] || applicationDetail.rejectedByRole})` : ''}`}
                            </Typography>
                          </Typography>

                        </Box>
                        {(!loading && applicationDetail?.clientCode) &&
                          <Box>
                            <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                              <Typography
                                variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                              >
                                Client Code:{' '}
                              </Typography>
                              <Typography
                                variant="h2"
                                sx={{
                                  display: 'inline',
                                  color: 'text.primary',

                                }}
                              >
                                {applicationDetail?.clientCode}
                              </Typography>
                            </Typography>
                          </Box>
                        }
                      </Box>

                    </>
                  )
                  }

                  {/* <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications">
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                    Summary
                  </Typography> */}
                </Box>
                {(
                  ![USER_ROLES.AMC_ADMIN].includes(role) &&
                  !loading &&
                  ((isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview)
                    ? !isCurrentStatusNotDraft
                    : editable
                  )
                ) && (
                    // <IconButton>
                    //   <CardMedia
                    //     component="img"
                    //     src="/images/edit-icon-outlined.svg"
                    //     alt="Edit Icon"
                    //     sx={{ width: 'unset' }}
                    //     onClick={() => history.push(`/application`, { id })}
                    //   />
                    // </IconButton>
                    <Button
                      variant="outlined"
                      startIcon={<EditIcon />}
                      sx={(theme: Theme) => ({
                        padding: '15px',
                        border: `0.5px solid ${theme.palette.text.primary}`,
                        borderRadius: '10px',
                        color: theme.palette.text.primary,
                        fontFamily: theme.typography.fontFamily,
                        fontSize: '18px',
                        fontWeight: 700,
                        cursor: 'pointer',

                      })}
                      onClick={() => history.push(`${(isDiyInvOnboardingApplicationDetails || isDiyInvOnboardingApplicationPreview) ? "/investor-onboarding-application/personal-details" : "/application"}`, { id })}
                    >
                      Edit
                    </Button>
                  )}
              </Box>
              <ApplicationDetailsCommonLayout
                loading={loading}
                application={applicationDetail as ApplicationProps}
              />
              {(["/investor-onboarding-application-preview/:id", "/application-preview/:id"].includes(path) && editable && !loading) && (
                <Box sx={{ textAlign: 'center' }}>
                  <LoadingButton
                    variant="contained"
                    sx={(theme: Theme) => ({
                      color: 'common.white',
                      // minWidth: '200px',
                      // minWidth: "457px",
                      mt: 4,
                      // fontWeight: 600,
                      // lineHeight: 1.5,
                      // fontSize: '16px',
                      ...theme.typography.body_700
                    })}
                    onClick={handleSendToActionBtnClick}
                    disabled={
                      (
                        isSubmitting ||
                        sendBackLoading ||
                        (isDiyInvOnboardingApplicationPreview
                          ? isCurrentStatusNotDraft
                          : false
                        ) ||
                        applicationDetail?.status === "sent_to_amc_approver" ||
                        applicationDetail?.status === "sent_to_compliance"
                      )}
                    loading={isSubmitting || sendBackLoading}
                    loadingPosition="center"
                  >
                    {`${sendToActionBtnText} ${(isSubmitting || sendBackLoading) ? '...' : ''}`}
                  </LoadingButton>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
        <IconButton
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton>
        <Dialog
          onClose={handleSendBackClose}
          open={openSendBackDialog}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 18,
                fontWeight: 500,
                textAlign: 'justify',
              },
            }}>
            {(
              isIndividualOnboarding &&
              isNomineeOptOutAuthRequired &&
              NOMINEE_OPT_OUT_FEATURE_ENABLED
            ) ? (
              <Typography sx={{ color: 'primary.main', mt: 2 }}>
                Application will be Sent to Checker post Nominee Opt Out Authentication
              </Typography>
            ) : (
              <Typography
                sx={{ color: 'primary.main', mt: 2 }}>{`Are you sure you want to send it to ${isDiyInvOnboardingApplicationPreview
                  ? "Checker"
                  : applicationDetail?.hasPOA
                    ? 'POA Approver'
                    : sendApplication_Nri(applicationDetail) ||
                      (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                      // ? 'Checker'
                      ? 'Compliance'
                      : 'Investor'
                  } ?`}</Typography>
            )}
            <Typography sx={{ color: 'primary.main', mt: 2 }}>Provide comments *</Typography>
            <Formik
              initialValues={initialCommentValues}
              onSubmit={onSendBackSubmit}
              validationSchema={Commentvalidation}>
              {({ handleSubmit }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <MFTextField
                    name="comment"
                    multiline
                    rows={4}
                    placeholder="Type your answer here..."
                  />

                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <Grid item>
                      <LoadingButton
                        loading={sendBackLoading}
                        variant="contained"
                        sx={(theme: Theme) => ({
                          // fontSize: 15,
                          // minWidth: 180,
                          // letterSpacing: 2,
                          // fontWeight: 400,
                          ...theme.typography.body_500
                        })}
                        type="submit">
                        Proceed{(
                          isIndividualOnboarding &&
                          isNomineeOptOutAuthRequired &&
                          NOMINEE_OPT_OUT_FEATURE_ENABLED
                        ) ? ' & Authenticate' : ''}
                      </LoadingButton>
                    </Grid>
                    <Grid item>
                      <Button
                        onClick={() => {
                          handleSendBackClose();
                        }}
                        variant="outlined"
                        sx={(theme: Theme) => ({
                          // fontSize: 15,
                          color: 'primary.main',
                          // minWidth: 180,
                          // letterSpacing: 2,
                          // fontWeight: 500,
                          ...theme.typography.body_500
                        })}
                        disabled={sendBackLoading}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Formik>
          </Box>
        </Dialog>
        <ConfirmationDialog
          message={`Sending details to ${isDiyInvOnboardingApplicationPreview
            ? 'Checker'
            : applicationDetail?.hasPOA
              ? 'POA Approver'
              : sendApplication_Nri(applicationDetail) ||
                (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                // ? 'Checker'
                ? 'Compliance'
                : 'Investor'
            }`}
          subMessage={`Are you sure you want to send it to ${isDiyInvOnboardingApplicationPreview
            ? 'Checker'
            : applicationDetail?.hasPOA
              ? 'POA Approver'
              : sendApplication_Nri(applicationDetail) ||
                (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                // ? 'Checker'
                ? 'Compliance'
                : 'Investor'
            } ?`}
          open={openDialog}
          setOpen={() => setDialog(false)}
          onSave={async () => {
            setDialog(false);
            handleSubmit();
          }}
          onCancel={() => setDialog(false)}
        />
        {/* DIY Investor Onboarding Checker Success Dialog Start */}
        <Dialog
          aria-labelledby="success-dialog"
          open={openDiyInvCheckerDialog}
          PaperProps={{
            sx: (theme: Theme) => ({
              maxWidth: '550px',
              width: "100%",
              borderRadius: "12px",
              padding: "24px",
              backgroundColor: theme.palette.common.white
            }),
          }}
        >
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              rowGap: "12px",
              padding: "15px",
              overflow: "hidden"
            }}
          >
            <SuccessIcon />
            <Typography
              variant="h2"
              sx={(theme: Theme) => ({
                lineHeight: "25px",
                letterSpacing: "0.01px",
                color: theme.palette.text.primary
              })}
            >
              Success
            </Typography>
            <Typography
              variant="subtitle_400"
              sx={(theme: Theme) => ({
                lineHeight: "22px",
                letterSpacing: "0.02px",
                color: theme.palette.text.secondary,
                textAlign: "center",
                paddingLeft: "10px",
                paddingRight: "10px"
              })}
            >
              Details successfully send to Checker
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              padding: "0px",
              marginTop: "40px",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              onClick={() => setDiyInvCheckerDialog(false)}
              sx={(theme: Theme) => ({
                ...theme.typography.body_500,
                fontWeight: 600,
                lineHeight: "20px",
                color: theme.palette.common.white,
                borderRadius: "4px",
                padding: "13px 20px",
                backgroundColor: theme.palette.primary[500]
              })}
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        {/* DIY Investor Onboarding Checker Success Dialog End */}

        {/* Nominee Opt Out OTP Dialog Start */}
        <Dialog
          open={isOtpDialogOpen}
          maxWidth="sm"
          sx={(theme: Theme) => ({
            '& .MuiPaper-root': {
              borderRadius: '12px',
              backgroundColor: theme.palette.common.white,
              padding: "24px 24px 5px 24px",
              flexDirection: "column",
              rowGap: "24px"
            }
          })}
        >
          <IconButton
            aria-label="close"
            onClick={handleOtpDialogClose}
            sx={(theme) => ({
              ...theme.typography.body_500,
              position: 'absolute',
              right: 3,
              top: 3,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <OTPForm
              onSubmit={handleNomineeOptOutOtpSubmit}
              onResend={handleNomineeOptOutOtpResend}
              otpMessage={applicationDetail?.message ?? ""}
              warningMessage=""
            />
          </DialogContent>
        </Dialog>
        {/* Nominee Opt Out OTP Dialog End */}

        {/* Verify OTP (Nominee Opt Out) Success Dialog Start */}
        <Dialog
          aria-labelledby="success-dialog"
          open={verifyOtpSuccessData?.isDialogOpen}
          PaperProps={{
            sx: (theme: Theme) => ({
              maxWidth: '550px',
              width: "100%",
              borderRadius: "12px",
              padding: "24px",
              backgroundColor: theme.palette.common.white
            }),
          }}
        >
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              rowGap: "12px",
              padding: "15px",
              overflow: "hidden"
            }}
          >
            <SuccessIcon />
            <Typography
              variant="h2"
              sx={(theme: Theme) => ({
                lineHeight: "25px",
                letterSpacing: "0.01px",
                color: theme.palette.text.primary
              })}
            >
              Success!
            </Typography>
            <Typography
              variant="subtitle_400"
              sx={(theme: Theme) => ({
                lineHeight: "22px",
                letterSpacing: "0.02px",
                color: theme.palette.text.secondary,
                textAlign: "center",
                paddingLeft: "10px",
                paddingRight: "10px"
              })}
            >
              {verifyOtpSuccessData?.data?.message ?? ""}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              padding: "0px",
              marginTop: "40px",
            }}
          >
            <Button
              fullWidth
              variant="contained"
              onClick={handleVerifyOtpSuccessDialogClose}
              sx={(theme: Theme) => ({
                ...theme.typography.body_500,
                fontWeight: 600,
                lineHeight: "20px",
                color: theme.palette.common.white,
                borderRadius: "4px",
                padding: "13px 20px",
                backgroundColor: theme.palette.primary[500]
              })}
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        {/* Verify OTP (Nominee Opt Out) Success Dialog End */}
      </>
    </LayoutComponent>
  ) : (
    <PoaOrNIApplicationDetails loading={loading} application={applicationDetail as ApplicationProps} />
  );
}
